const toPrettyCurrency = (value: number, currency: Currency) => {
  const n = Number(value);
  return `${currency} ${(Number.isFinite(n) ? n : 0).toFixed(2)}`;
};

export default toPrettyCurrency;